import { render, staticRenderFns } from "./LifemapLegend.vue?vue&type=template&id=97f23bf0&"
import script from "./LifemapLegend.vue?vue&type=script&lang=js&"
export * from "./LifemapLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports